// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1qcI5","cell":"ColumnAccessor_cell__2Ztc-","firstCellAccent":"ColumnAccessor_firstCellAccent__2NFyF"};